import { Record } from "immutable";
import { SETTINGS_DATA_SOURCE_TYPES } from "@infinode/components/settings/constants";

const TrendAnalysisDataItemRecord = Record({
  timestamp: null, // timestamp
  [SETTINGS_DATA_SOURCE_TYPES.NET_IMPORT]: null,
  [SETTINGS_DATA_SOURCE_TYPES.CONSUMED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.GENERATED]: null,
  [SETTINGS_DATA_SOURCE_TYPES.STORAGE]: null
});
 
const createTrendAnalysisDataItemRecord = dataItem => {
  return TrendAnalysisDataItemRecord(dataItem);
};

export { createTrendAnalysisDataItemRecord };

export default TrendAnalysisDataItemRecord;
